<div class="grid">
    <div class="lg:col-3 md:col-2 col-12">
      <kanzi-floormap-items-palette (roomSelected)="onSelectedRoom($event)"></kanzi-floormap-items-palette>
    </div>
    <div class="lg:col-9 md:col-10 col-12">
      <kanzi-floormap-toolbar [editorMode]="true"></kanzi-floormap-toolbar>
      <kanzi-apes-floormap-content-editor
        [floorDataComplete]="floorDataComplete"
        (dataFloorExtrasSave)="onSaveExtrasFloor($event)"
        (dataFloorLocationsSave)="onSaveLocationsFloor($event)"
        (dataFloorExtrasDelete)="onDeleteExtrasFloor($event)"
      ></kanzi-apes-floormap-content-editor>
    </div>
  </div>
  
  <p-confirmDialog></p-confirmDialog>